import { FC, PropsWithChildren, memo } from 'react'

import * as SC from './styles'

export const FilterWrapper: FC<PropsWithChildren> = memo(({ children }) => {
  return <SC.FilterWrapper>{children}</SC.FilterWrapper>
})
